// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__A-Rob","l5":"Loader_l5__n-2Tl"};